<template>
  <div :class="['card', classes.card]">
    <div class="card-header-icon">
      <h2 class="h4 mb-0">{{ title }}</h2>
      <i :class="`bx ${icon}`" aria-hidden="true" />
    </div>
    <div class="card-body p-0">
      <SiteContent :name="PROJECTS_DASHBOARD_START_NEW_PROJECTS" />
    </div>
    <slot name="footer" />
  </div>
</template>

<script setup>
import { toRefs } from 'vue'

import SiteContent from '@shared/components/SiteContent.vue'
import { PROJECTS_DASHBOARD_START_NEW_PROJECTS } from '@shared/constants/siteContent'

const props = defineProps({
  title: {
    type: String,
    default: 'Start New Projects',
  },
  icon: {
    type: String,
    default: 'bx-chevron-right-square',
  },
  classes: {
    type: Object,
    default: () => ({}),
  },
})

const { classes, title, icon } = toRefs(props)
</script>
